import * as constants from './constants'

// NOTE: decomposing and recomposing the action payload is more verbose than we need to be
// but it'll help anybody who jumps into this project unerstand how to use the actions

export const receiveAllRuleData = ({
  ruleGroups,
  rules,
  ruleTree,
  teams,
  defaultRuleUsers,
}) => ({
  type: constants.RECEIVE_ALL_RULE_DATA,
  payload: {
    ruleGroups,
    rules,
    ruleTree,
    teams,
    defaultRuleUsers,
  },
})

export const addNewRule = ({ groupId, indexInGroup, routingRuleIdField }) => ({
  type: constants.NEW_RULE,
  payload: {
    groupId,
    indexInGroup,
    routingRuleIdField,
  },
})

export const updateDraftRule = ({ ruleUpdates, ruleId }) => ({
  type: constants.UPDATE_RULE,
  payload: {
    ruleUpdates,
    ruleId,
  },
})

export const deleteDraftRule = ({ ruleId, routingRuleIdField }) => ({
  type: constants.DELETE_RULE,
  payload: {
    ruleId,
    routingRuleIdField,
  },
})

export const deleteDraftGroup = ({ groupId }) => ({
  type: constants.DELETE_RULE_GROUP,
  payload: {
    groupId,
  },
})

export const pointRuleToNewGroup = ({ ruleId, routingRuleIdField }) => ({
  type: constants.POINT_RULE_TO_NEW_GROUP,
  payload: {
    ruleId,
    routingRuleIdField,
  },
})

export const updateDraftDefaultRuleGroupAction = ({ action, groupId }) => ({
  type: constants.UPDATE_DEFAULT_RULE_GROUP_ACTION,
  payload: {
    action,
    groupId,
  },
})

export const pointDefaultGroupActionToNewGroup = ({
  groupId,
  routingRuleIdField,
}) => ({
  type: constants.POINT_DEFAULT_GROUP_ACTION_TO_NEW_GROUP,
  payload: {
    groupId,
    routingRuleIdField,
  },
})

export const saveDraft = () => ({ type: constants.SAVE_DRAFT })
export const draftPublished = () => ({ type: constants.DRAFT_PUBLISHED })
export const draftSaveDone = ({ rules, ruleGroups, defaultRuleUsers }) => ({
  type: constants.DRAFT_SAVE_DONE,
  payload: {
    rules,
    ruleGroups,
    defaultRuleUsers,
  },
})
export const draftSaveFailed = (err) => ({
  type: constants.DRAFT_SAVE_FAILED,
  payload: err,
})

export const revertToPublishedVersion = () => ({
  type: constants.REVERT_TO_PUBLISHED_VERSION,
})

export const setShowPublished = ({ showingPublished }) => ({
  type: constants.SET_SHOW_PUBLISHED,
  payload: {
    showingPublished,
  },
})

export const updateDraftDefaultUserIds = ({ userIds }) => ({
  type: constants.UPDATE_DRAFT_DEFAULT_USER_IDS,
  payload: { userIds },
})

export const showSelectContinueToGroup = ({ ruleId, groupId }) => ({
  type: constants.SHOW_SELECT_CONTINUE_TO_GROUP,
  payload: {
    ruleId,
    groupId,
  },
})

export const chooseSelectContinueToGroup = ({ groupId }) => ({
  type: constants.CHOOSE_SELECT_CONTINUE_TO_GROUP,
  payload: {
    groupId,
  },
})

export const cancelSelecting = () => ({
  type: constants.CANCEL_SELECT_CONTINUE_TO_GROUP,
  payload: {},
})

export const moveRule = ({ from, to, routingRuleIdField }) => ({
  type: constants.MOVE_RULE,
  payload: { from, to, routingRuleIdField },
})

export const setShowAddingNewRule = ({ showing, ruleId }) => ({
  type: constants.SET_SHOW_ADDING_NEW_RULE,
  payload: {
    showing,
    ruleId,
  },
})

export const setShowEditAction = ({ showing, ruleId, groupId }) => ({
  type: constants.SET_SHOW_EDIT_ACTION,
  payload: {
    showing,
    ruleId: ruleId || groupId ? `${ruleId}-${groupId}` : '',
  },
})

export const setHideOptInFlow = ({ shouldHide }) => ({
  type: constants.SET_HIDE_OPT_IN_FLOW,
  payload: {
    shouldHide,
  },
})
